// extracted by mini-css-extract-plugin
export default {"main":"PreProjection_main__hQesO","cover1":"PreProjection_cover1__XapyQ","flex_col":"PreProjection_flex_col__HcIe3"};